/**
 * 背景画像。
 *
 * 以前は 3 枚からランダムに選んでいたが、読み込むたびに絵が変わるので
 * 「いま何を告知しているのか」が定まらなかった。1 枚に固定する。
 *
 * ファイル名に年月を入れているのは、同じ URL を上書きすると配信側が
 * 古い画像を返し続けることがあるため。差し替えるときは新しい名前で
 * 上げて、ここを書き換える
 */
const BANNER_IMAGE =
  "https://storage.chotdekiru.com/campaigns/topbanner/fixed-header-2026-08.png";

export interface CampaignBannerProps {
  /**
   * バナー全体のリンク先
   */
  href?: string;
  /**
   * 閉じるボタンのクリックハンドラ
   */
  onClose?: () => void;
}

export function CampaignBanner({
  href = "/learn/courses/ai-engineer-trial",
  onClose,
}: CampaignBannerProps) {
  const opensNewTab = /^https?:\/\//.test(href);

  return (
    <a
      href={href}
      target={opensNewTab ? "_blank" : undefined}
      rel={opensNewTab ? "noopener noreferrer" : undefined}
      className="relative block w-full h-10 bg-[#05b45b] bg-cover bg-center hover:opacity-90 transition-opacity"
      style={{ backgroundImage: `url(${BANNER_IMAGE})` }}
    >
      {onClose && (
        <button
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            onClose();
          }}
          className="absolute right-2 top-1/2 -translate-y-1/2 flex items-center justify-center p-2 text-white hover:opacity-80 transition-opacity"
          aria-label="バナーを閉じる"
        >
          <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M12 4L4 12M4 4L12 12"
              stroke="currentColor"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </button>
      )}
    </a>
  );
}
